// removed by extract-text-webpack-plugin
module.exports = {"Post":"_1E8OAUiv2l3jdVKauIlaQ-","Date":"DjaL-V3PqZt3Oxju2YIXk","Rating":"_12roztStLdL9UxKS_5XQl8","FeedbackText":"_3nDQUJLLRtPsccte9jeLbx"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/CategoryUpdate/PostHistory/Post/style.css
// module id = 2471
// module chunks = 0